import { mount } from "@vue/test-utils";
import GoImage from "@/components/core/GoImage";

describe("GoImage test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(GoImage);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component GoImage", () => {
    expect(wrapper).toBeDefined();
  });
});
